import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import WorkflowType from './WorkflowType'
import WorkflowTypes from './WorkflowTypes'
import CreateWorkflowType from './CreateWorkflowType'

const WorkflowTypesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <WorkflowTypes />
      </Route>

      <Route path={`${path}/create-workflow-type`}>
        <CreateWorkflowType />
      </Route>

      <Route path={`${path}/:workflowTypeId`}>
        <WorkflowType />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default WorkflowTypesRoutes
